<template>
  <div class="main">
    <BasicTemplate :page-id="0" v-if="data">
      <Banner :list="data.banner.list" />
      <Advantage
        :title="data.advantage.title"
        :desc="data.advantage.desc"
        :list="data.advantage.list"
      />
      <Quality :info="data.quality.info" />
      <ProdLines :info="data.prod.info" :list="data.prod.list" />
      <Cards :list="data.cards.list" />
      <NewsWidget v-if="data && news" :info="data.news.info" :list="news" />
      <template slot="modal">
        <ModalDialogNews :news-id="$route.params.id" ref="modalNews" />
      </template>
    </BasicTemplate>
  </div>
</template>

<script>
import BasicTemplate from "./BasicTemplate.vue";
import Banner from "../containers/Banner.vue";
import Advantage from "../containers/Advantage.vue";
import Quality from "../containers/Quality.vue";
import ProdLines from "../containers/ProdLines.vue";
import Cards from "../containers/Cards.vue";
import NewsWidget from "../containers/NewsWidget.vue";

import utils from "../utils";
import firestoreUtils from "../firestore-utils";
import ModalDialogNews from "../containers/ModalDialogNews.vue";

export default {
  name: "Home",
  data() {
    return {
      data: undefined,
      news: undefined,
      utils: utils,
      metaTitle: undefined,
      metaDescription: undefined,
      metaKeywords: undefined,
      metaImage: undefined,
      metaUrl: undefined,
      countPerPage: 3,
    };
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        { name: "yandex-verification", content: "b7c03678b09c3394" },
        {
          name: "title",
          property: "title",
          content: this.metaTitle,
        },
        {
          name: "description",
          property: "description",
          content: this.metaDescription,
        },
        {
          name: "keywords",
          property: "keywords",
          content: this.metaKeywords,
        },
        {
          name: "og:title",
          property: "og:description",
          content: this.metaTitle,
        },
        {
          name: "og:description",
          property: "og:description",
          content: this.metaDescription,
        },
        {
          name: "og:image",
          property: "og:image",
          content: this.metaImage,
        },
        {
          name: "og:url",
          property: "og:url",
          content: this.metaUrl,
        },
      ],
    };
  },

  methods: {},
  mounted() {
    // firestoreUtils.uploadAppData();
    firestoreUtils.fetchData("home").then(data => {
      this.data = data;
      this.metaUrl = window.location.href;
      this.metaImage = data.meta.img.src;
      this.metaTitle = data.meta.title;
      this.metaDescription = data.meta.description;
      this.metaKeywords = data.meta.keywords;
      setTimeout(() => {
        document.dispatchEvent(new Event("x-app-rendered"));
      }, 5000);
    });
    firestoreUtils
      .fetchWithFilter(
        "newslist",
        {
          field: "id",
          condition: "<=",
          value: 100000,
        },
        this.countPerPage,
        this.last,
        "id",
        "desc"
      )
      .then(result => {
        this.last = result.last;
        result.data.forEach(element => {
          delete element.desc;
          element.date = this.utils.parseDate(element.date);
        });
        this.news = [...result.data];
      });
  },
  components: {
    BasicTemplate,
    Banner,
    Advantage,
    Quality,
    ProdLines,
    Cards,
    NewsWidget,
    ModalDialogNews,
  },
};
</script>

<style lang="scss">
.main {
  .banner-header .description .more {
    @media all and (max-width: $md) {
      margin-bottom: 25px;
      margin-top: 20px;
    }
  }
}
</style>
